import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["field", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

// Utils
import { validateField } from '../../validation/validationUtil';
var FinalField = function FinalField(props) {
  var field = props.field,
    children = props.children,
    finalFieldProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Field, _extends({
    name: field.name,
    validate: validateField(field),
    type: field.type
  }, finalFieldProps), function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    // Prioritise on showing submission errors if it exist and
    // the form has not been modified after last submit
    var error = meta.submitError && !meta.modifiedSinceLastSubmit ? meta.submitError : meta.error;

    // `display` contains form information that has been processed for form display purposes
    var display = {
      error: meta.touched ? error : undefined
    };
    return children({
      input: _objectSpread(_objectSpread({}, input), {}, {
        type: field.type,
        maxLength: field.maxLength
      }),
      meta: meta,
      display: display
    });
  });
};
FinalField.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired
};
export default FinalField;